import React from "react";
import {
  Modal,
  Box,
  SpaceBetween,
  Button,
  FormField,
  Input,
  Multiselect,
  Select,
  Spinner,
  Header,
  Alert
} from "@amzn/awsui-components-react";

const CreateTeamModal = ({
  visible,
  onDismiss,
  onCreateTeam,
  isPortalAdmin,
  isSupportAdmin,
  modalLoading,
  errorText,
  newTeamName,
  setNewTeamName,
  newTeamLDAP,
  setNewTeamLDAP,
  selectedOrgs,
  setSelectedOrgs,
  selectedRegions,
  setSelectedRegions,
  selectedVP,
  setSelectedVP,
  organizations,
  regions,
  directReports,
  getDirectReportsCaller
}) => {
  return (
    <Modal
      onDismiss={onDismiss}
      visible={visible}
      footer={
        <>
          {errorText && (
            <Alert type="error" statusIconAriaLabel="Error">
              {errorText}
            </Alert>
          )}
          <Box float="right">
            <SpaceBetween direction="horizontal" size="xs">
              <Button variant="link" onClick={onDismiss}>Cancel</Button>
              <Button 
                variant="primary" 
                onClick={() => onCreateTeam()} 
                disabled={!(isPortalAdmin || isSupportAdmin)}
              >
                Create team
              </Button>
            </SpaceBetween>
          </Box>
        </>
      }
      header="Create Team"
    >
      {modalLoading ? <Spinner /> : (
        <>
          <Header variant="h3">
            <Box color="text-status-info">Create a new team</Box>
          </Header>

          <FormField label="Your Team's Display name">
            <Input 
              onChange={({ detail }) => setNewTeamName(detail.value)}
              value={newTeamName}
              placeholder='Team name'
            />
          </FormField>

          <FormField label="LDAP">
            <Input 
              onChange={({ detail }) => setNewTeamLDAP(detail.value)}
              value={newTeamLDAP}
              placeholder='LDAP group'
            />
          </FormField>

          <FormField label="Organization">
            <Multiselect
              selectedOptions={selectedOrgs}
              onChange={({ detail }) => setSelectedOrgs(detail.selectedOptions)}
              options={organizations}
              placeholder="Choose Organizations"
            />
          </FormField>

          <FormField label="Region">
            <Multiselect
              selectedOptions={selectedRegions}
              onChange={({ detail }) => setSelectedRegions(detail.selectedOptions)}
              options={regions}
              placeholder="Choose Regions"
            />
          </FormField>

          <FormField label="VP">
            <Select
              selectedOption={selectedVP}
              onChange={({ detail }) => setSelectedVP(detail.selectedOption)}
              placeholder="Select a VP Alias"
              options={directReports}
              onLoadItems={() => {
                getDirectReportsCaller('shelleyr')
              }}
            />
          </FormField>
        </>
      )}
    </Modal>
  );
};

export default CreateTeamModal;
